import axiosInstance from '../services/AxiosInstance';
import { clearCache } from './requestCache';

const API_URL = '/events';

// Get events with pagination, search, and filters
export const getEvents = async (
  limit = 10,
  page = 1,
  search = '',
  searchField = 'all',
  trainerId = null,
  batchId = null,
  category = null
) => {
  try {
    const params = {
      limit: Number(limit),
      page: Number(page),
    };
    
    if (search && search.trim() !== '') {
      params.search = search.trim();
      params.searchField = searchField;
    }
    
    if (trainerId) {
      params.trainerId = trainerId;
    }
    
    if (batchId) {
      params.batchId = batchId;
    }

    if (category) {
      params.category = category;
    }
    
    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching events', error);
    throw error;
  }
};

// Get event by ID
export const getEventById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event', error);
    throw error;
  }
};

// Create a new event
export const createEvent = async (eventData) => {
  try {
    const response = await axiosInstance.post(API_URL, eventData);
    // The calendar view (CalendarService.getCalendarEvents) caches reads for
    // 10s keyed by the exact query params. Without this, saving an event and
    // immediately re-fetching the same view (which is exactly what the
    // calendar does right after a save) silently serves the pre-creation
    // cached list — the event is really saved, it just doesn't appear.
    clearCache('calendar:events:');
    return response.data;
  } catch (error) {
    console.error('Error creating event', error);
    throw error;
  }
};

// Update an event
export const updateEvent = async (id, eventData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, eventData);
    clearCache('calendar:events:');
    return response.data;
  } catch (error) {
    console.error('Error updating event', error);
    throw error;
  }
};

// Delete an event
export const deleteEvent = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${id}`);
    clearCache('calendar:events:');
    return response.data;
  } catch (error) {
    console.error('Error deleting event', error);
    throw error;
  }
};